<main class="media-page">
  <section class="media-hero">
    <div class="media-hero-inner">
      <a routerLink="/resources" class="media-back-link">
        <i class="bx bx-chevron-left" aria-hidden="true"></i>
        <span>Back to Resources</span>
      </a>
      <div class="media-hero-copy">
        <span class="media-kicker">Varroc Connect · Media</span>
        <h1>Ideas made <span>visible.</span></h1>
        <p>Explore our product creatives and discover the connected mobility solutions behind them.</p>
      </div>
      <div class="media-hero-count" aria-label="7 product creatives">
        <strong>07</strong>
        <span>Product<br>creatives</span>
      </div>
    </div>
  </section>

  <section class="media-gallery" aria-labelledby="media-gallery-title">
    <div class="gallery-heading">
      <div>
        <h2 id="media-gallery-title">The creative library</h2>
        <p>Choose a creative to explore its related product.</p>
      </div>
      <span class="gallery-count">{{ mediaCreatives.length }} creatives</span>
    </div>

    <div class="media-grid">
      <a *ngFor="let creative of mediaCreatives; let i = index"
         class="media-card"
         [routerLink]="creative.href"
         [attr.aria-label]="creative.title + ' — explore product'">
        <div class="media-artwork">
          <img [src]="creative.image" [alt]="creative.alt" [attr.loading]="i < 3 ? 'eager' : 'lazy'">
          <span class="artwork-open" aria-hidden="true"><i class="bx bx-arrow-back"></i></span>
        </div>
        <div class="media-card-copy">
          <span class="media-category">{{ creative.category }}</span>
          <h3>{{ creative.title }}</h3>
          <p>{{ creative.description }}</p>
          <span class="media-card-link">Explore product <i class="bx bx-right-arrow-alt" aria-hidden="true"></i></span>
        </div>
      </a>
    </div>
  </section>
</main>
